module.exports = __webpack_public_path__ + "img/pro_ar_02.72604ad1.jpg";